<template>
  <div class="container">
    <div class="week">
      <div @click="displayWeek('prev')">prev</div>
      <div v-for="(day, index) in weeks[currentWeekIndex]" :key="index" class="day">
        <div>{{ getMiles(day.distance) }} miles</div>
        <div>{{ moment(day.start_date).format('dddd') }}</div>
      </div>
      <div @click="displayWeek('next')">next</div>
    </div>
    <div class="weeks-over-time">
      <div v-for="(week, index) in weeks" :key="index" class="week-column">
        {{ totalWeeklyDistance(week) }}
      </div>
    </div>
  </div>
</template>

<script>
//https://codeburst.io/javascript-arrays-finding-the-minimum-maximum-sum-average-values-f02f1b0ce332
  import moment from 'moment'
  import _ from 'lodash'
  import { mapGetters } from 'vuex'
  import { getMiles } from '@/helpers/conversion'

  export default {
    name: 'Weeks',
    components: {},
    mixins: {},
    props: [''],
    data() {
      return {
        currentWeekIndex: null
      }
    },
    computed: {
      ...mapGetters([
        'getActivitiesOverTime'
      ]),
      // totalWeeks() {
      //   return this.weeks.length - 1
      // },
      // currentWeekIndex: {
      //   get() {
      //     return this.weeks.length - 1
      //   },
      //   set(newValue) {
      //     return newValue
      //   }
      // },
      weeks() {
        // group weeks
        const weeksGrouped = _.groupBy(this.getActivitiesOverTime, range => moment(range['start_date']).startOf('isoWeek'))
        // push array of arrays
        const array = []
        for (const key in weeksGrouped) {
          if (weeksGrouped.hasOwnProperty(key)) {
            array.push(weeksGrouped[key])
          }
        }
        return array
      }
    },
    watch: {},
    // lifecycle events
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    mounted() {
      this.currentWeekIndex = this.weeks.length - 1 
      // console.log(this.weeks)
      // console.log(moment().isoWeek())
    },
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeDestroy() {},
    // destroyed() {},
    methods: {
      moment,
      getMiles,
      displayWeek(move) {
        const position = (move == 'next') ? this.currentWeekIndex + 1 : this.currentWeekIndex - 1 
        if (position > this.weeks.length - 1) return
        if (position == 0) return
        this.currentWeekIndex = position
      },
      totalWeeklyDistance(week) {
        // return week.length
        // return week.reduce((a, b) => a + b.distance)
        const sum = week.reduce((acc, val) => {
          return acc + (val.distance || 0)
        }, 0)
        return getMiles(Math.round(sum))
      }
      // dayOfWeek(day) {
      //   return moment(day).format('ddd')
      // }
    }
  }
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
}
  .week {
    display: flex;
    align-items: center;
    height: 100px;
    border: 1px solid $light-gray;
    margin: 10%;
    user-select: none;
    .day {
      flex: 1;
      display: flex;
      align-items: center;
      flex-direction: column;
    }
  }
  .weeks-over-time {
    display: flex;
    flex-wrap: wrap;
    .week-column {
      flex: 1;
    }
  }
</style>